import { useContext } from "react";

import { PreferencesContext, type Preferences } from "@/app/preferencesContext";

export function usePreferences(): Preferences {
  const ctx = useContext(PreferencesContext);
  if (!ctx) {
    throw new Error("usePreferences must be used within a PreferencesProvider");
  }
  return ctx;
}